<template>
  <v-btn
    flex-row-reverse
    :disabled="isDisabled"
    :loading="loading"
    icon
    @click="confirmTerminate()"
  >
    <v-icon>
      mdi-download-box-outline
    </v-icon>
  </v-btn>
</template>

<script>
import ReportsRequest from 'Domain/reports/ReportsRequest';
import notificationMixin from 'Support/mixins/notification-mixin';

export default {
  name: 'ReportTerminateList',
  mixins: [notificationMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    row: {
      type: Object,
      default() {
        return {
          status: '',
        };
      },
    },
  },
  data: () => ({
    requestClass: ReportsRequest,
    loading: false,
  }),
  computed: {
    getId() {
      return this.value;
    },
    isDisabled() {
      return this.getStatus !== 'FINALIZADO';
    },
    getStatus() {
      return this.row.status;
    },
    getDialogProps() {
      return {
        title: 'Baixar relatório?',
        text: 'Deseja baixar como csv o relatório',
      };
    },
  },
  methods: {
    confirmTerminate() {
      this.showConfirmDialog(
        this.getDialogProps,
      ).then(
        this.prepareTerminate,
      );
    },
    prepareTerminate(res) {
      if (res.value) {
        this.handleTerminate();
      }
    },
    async handleTerminate() {
      try {
        this.handleLoading();
        const response = await this.requestClass.generate(this.getId);
        this.showNotification('success');
        this.makeFileToDownload(response);
      } catch (err) {
        this.showNotification('err', err);
      } finally {
        this.handleLoading();
      }
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    showNotification(type, err = null) {
      if (type === 'success') {
        this.showSuccessToast({
          title: 'Sucesso',
          text: 'Sucesso ao solicitar download de relatório',
        });
      } else {
        this.showErrorToast({
          title: 'Erro',
          text: this.getFaultMessageError(err),
        });
      }
    },
    getFaultMessageError(err) {
      const faultMessage = 'Falha ao solicitar download de relatório';
      if (!err) return faultMessage;
      if ('response' in err) return err.response.statusText;
      if ('message' in err) return err.message;
      return faultMessage;
    },
    makeFileToDownload(response) {
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
      const fileName = this.prepareFileName(response);
      const link = document.createElement('a');

      link.download = fileName;
      link.href = URL.createObjectURL(blob, { type: 'text/plain' });
      link.click();
      URL.revokeObjectURL(link.href);
    },
    prepareFileName(response = {}) {
      const faultName = this.$options.name;

      if (!response.headers) return faultName;

      const header = response.headers['content-disposition'];
      if (this.isString(header)) {
        return String(String(header).split('filename=')[1].split(';')[0]).replace('"', '').replace('"', '');
      }

      const url = response.request.responseURL;
      if (this.isString(url)) {
        const lastBarIndex = String(url).lastIndexOf('/');
        return String(url).split('').slice(lastBarIndex)
          .join('');
      }

      return faultName;
    },
    isString(item) {
      return item && typeof item === 'string';
    },
  },
};
</script>
